import { useDispatch, useSelector } from "react-redux";
import { clearAllErrors } from "../../../actions/errorActions";
import { Alert } from "reactstrap";

export default function ErrorAlert(props) {
    const dispatch = useDispatch();
    const errorMessage = useSelector(state => {
        if (state?.apiErrors?.activeErrors?.length) {
            let activeError = state.apiErrors.activeErrors[0];
            if (activeError?.error?.userMessage) {
                return activeError.error.userMessage;
            }
            if (activeError?.actionId?.includes?.('scanAvailability')) {
                return 'We could not load appointment availability right now.';
            }
            if (activeError?.actionId === 'APPOINTMENT_RESERVE') {
                return 'An error occurred while attempting to reserve timeslot.';
            }
            return 'An error occurred while attempting to search.';
        } else {
            return null;
        }
    });

    if (errorMessage)
        return (
            <div>
                <Alert
                    color="danger"
                    toggle={
                        () =>
                            dispatch(clearAllErrors())
                    }
                >
                    {errorMessage}
                </Alert>
            </div>
        );

    return null;
}